import React from 'react';

export const VaultPane = ({
  vaultUnlocked,
  vaultPasswordInput,
  setVaultPasswordInput,
  vaultError,
  vaultRecords,
  vaultDraftTitle,
  setVaultDraftTitle,
  vaultDraftCategory,
  setVaultDraftCategory,
  vaultDraftBody,
  setVaultDraftBody,
  handleUnlockVault,
  handleAddVaultRecord,
  handleDeleteVaultRecord,
  handleLockVault,
  selectedVaultRecord,
  setSelectedVaultRecord,
  t
}) => {
  if (!vaultUnlocked) {
    return (
      <div className="chat-container" style={{ padding: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <div className="glass-panel" style={{ padding: '30px', maxWidth: '400px', width: '100%', borderRadius: '12px', border: '1px solid var(--border-color)', background: 'rgba(0,0,0,0.2)' }}>
          <div style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '15px' }}>🔒</div>
          <h3 style={{ textAlign: 'center', marginBottom: '10px', fontSize: '1.2rem', fontWeight: 800 }}>{t('vault_title') || 'GaiaVault Secure Records'}</h3>
          <p style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', textAlign: 'center', marginBottom: '20px', lineHeight: '1.4' }}>
            {t('vault_desc') || 'Lokaler verschlüsselter Tresor für Recovery-Backups, Identitätsnotizen, Server-Zugänge, Notfallkontakte und private Logs.'}
          </p>
          <form onSubmit={handleUnlockVault}>
            <div className="form-group">
              <input
                type="password"
                className="input-field"
                placeholder={t('vault_pwd_placeholder') || 'Vault-Passwort eingeben...'}
                value={vaultPasswordInput}
                onChange={e => setVaultPasswordInput(e.target.value)}
                required
              />
            </div>
            {vaultError && <p style={{ color: 'var(--danger)', fontSize: '0.8rem', marginTop: '-8px', marginBottom: '12px' }}>{vaultError}</p>}
            <button type="submit" className="btn-primary" style={{ width: '100%' }}>
              {t('vault_btn_unlock') || 'Tresor entsperren'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-container" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <header className="reader-header" style={{ padding: '10px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ fontSize: '1.8rem' }}>🔑</div>
          <div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 800 }}>GaiaVault</h3>
            <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
              {vaultRecords.length} {t('records_stored') || 'Records gesichert'}
            </span>
          </div>
        </div>
        <button type="button" className="btn-secondary" style={{ color: 'var(--warning)', borderColor: 'var(--warning)' }} onClick={handleLockVault}>
          {t('vault_btn_lock') || 'Tresor sperren'}
        </button>
      </header>

      <div style={{ flex: 1, padding: '24px', overflowY: 'auto', display: 'grid', gridTemplateColumns: selectedVaultRecord ? '1fr' : '1fr', gap: '20px' }}>
        {selectedVaultRecord ? (
          <div className="glass-panel" style={{ padding: '20px', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px' }}>
              <div>
                <span className="badge" style={{ background: 'var(--accent-cyan)', color: 'var(--bg-primary)', fontSize: '0.7rem', padding: '2px 8px', borderRadius: '4px', textTransform: 'uppercase', fontWeight: 'bold' }}>
                  {selectedVaultRecord.category}
                </span>
                <h4 style={{ fontSize: '1.2rem', marginTop: '8px', fontWeight: 800 }}>{selectedVaultRecord.title}</h4>
                <small style={{ color: 'var(--text-muted)' }}>
                  {new Date(selectedVaultRecord.createdAt).toLocaleString()}
                </small>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button type="button" className="btn-secondary" onClick={() => setSelectedVaultRecord(null)}>
                  {t('close') || 'Schließen'}
                </button>
                <button type="button" className="btn-primary" style={{ background: 'var(--danger)', color: '#fff', borderColor: 'var(--danger)' }} onClick={() => handleDeleteVaultRecord(selectedVaultRecord.id)}>
                  {t('delete') || 'Löschen'}
                </button>
              </div>
            </div>
            <pre style={{
              background: 'rgba(0,0,0,0.15)',
              padding: '16px',
              borderRadius: '6px',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
              fontFamily: 'monospace',
              fontSize: '0.85rem',
              color: 'var(--text-primary)',
              lineHeight: '1.5',
              border: '1px solid var(--border-color)'
            }}>
              {selectedVaultRecord.body}
            </pre>
          </div>
        ) : (
          <div className="glass-panel" style={{ padding: '20px', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
            <h4 style={{ marginBottom: '15px', fontWeight: 800 }}>{t('vault_new_record') || 'Neuen Secure Record anlegen'}</h4>
            <form onSubmit={handleAddVaultRecord}>
              <div className="form-group">
                <label>{t('vault_record_title') || 'Titel'}</label>
                <input
                  type="text"
                  className="input-field"
                  placeholder={t('vault_record_title_placeholder') || 'Titel des Secure Records'}
                  value={vaultDraftTitle}
                  onChange={e => setVaultDraftTitle(e.target.value)}
                  maxLength={80}
                  required
                />
              </div>

              <div className="form-group">
                <label>{t('vault_record_category') || 'Kategorie'}</label>
                <select
                  className="input-field"
                  value={vaultDraftCategory}
                  onChange={e => setVaultDraftCategory(e.target.value)}
                  style={{ background: 'var(--bg-secondary)', color: 'var(--text-primary)' }}
                >
                  <option value="identity">Identity Notes</option>
                  <option value="credentials">Server Credentials</option>
                  <option value="emergency">Emergency Contacts</option>
                  <option value="legal">Legal Notes</option>
                  <option value="private_logs">Private Logs / Records</option>
                </select>
              </div>

              <div className="form-group">
                <label>{t('vault_record_body') || 'Inhalt (Verschlüsselt)'}</label>
                <textarea
                  className="input-field"
                  placeholder={t('vault_record_body_placeholder') || 'Verschlüsselten Record-Inhalt eingeben...'}
                  value={vaultDraftBody}
                  onChange={e => setVaultDraftBody(e.target.value)}
                  style={{ minHeight: '160px', fontFamily: 'monospace' }}
                  maxLength={5000}
                  required
                />
              </div>

              {vaultError && <p style={{ color: 'var(--danger)', fontSize: '0.8rem', marginBottom: '12px' }}>{vaultError}</p>}

              <button type="submit" className="btn-primary">
                {t('vault_btn_encrypt') || 'Record verschlüsseln'}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default VaultPane;
